import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Container } from "@bw/bits"
import { Breadcrumbs } from "@bw/partials"
import { breakpoints } from "../../../theme"

const PageHeaderWrapper = styled.div`
  padding: 100px 0 0;
  background-size: cover;
  width: 100%;
  color: var(--text-color);

  @media (min-width: ${breakpoints.small}px) {
    padding: 200px 0 0;
  }
`

const StyledHeading = styled.div`
  line-height: 1.2;

  @media (min-width: ${breakpoints.small}px) {
    padding-right: 65px;
  }
`

const Suptitle = styled.div`
  line-height: 1.7;
  font-size: 14px;
  font-weight: 600;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 18px;
  }
`

const Title = styled.h1`
  margin: 0;
  font-weight: 700;
  font-size: 27px;
  font-weight: 700;
  line-height: 1.2;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 35px;
  }

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 45px;
  }
`

const Subtitle = styled.div`
  line-height: 1.7;
  font-size: 14px;
  max-width: 500px;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 18px;
  }
`

const PageHeader = ({
  title,
  suptitle,
  subtitle,
  containerSize,
  breadcrumbs,
  image,
}) => {
  return (
    <PageHeaderWrapper image={image}>
      <Container size={containerSize}>
        <StyledHeading>
          {suptitle && <Suptitle>{suptitle}</Suptitle>}
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </StyledHeading>
        {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      </Container>
    </PageHeaderWrapper>
  )
}

PageHeader.propTypes = {
  image: PropTypes.string,
  suptitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string,
  subtitle: PropTypes.any,
  containerSize: PropTypes.oneOf(["small", "medium", "large"]),
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

PageHeader.defaultProps = {
  containerSize: "medium",
}

export { PageHeader }
